export const adminsTable = {
  header: 'Admins',

  id: 'User ID',
  name: 'User Name',
  email: 'User Email',
  created_by: 'Created By',
};
export const attachUser = {
  attach: 'Attach User',

  client: 'Client',
  admins: 'Admins',
  selectPlaceholder: 'Select',
};
